import styles from './MockThumb.module.css';

interface MockThumbProps {
  src: string;
  alt: string;
  className?: string;
}

function MockThumb({ src, alt, className = '' }: MockThumbProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={[styles.thumb, className].filter(Boolean).join(' ')}
      loading="lazy"
      decoding="async"
    />
  );
}

export default MockThumb;
